import React, { FC, Fragment } from "react";
import { ListItem } from "@material-ui/core";

import Loader from "../../Loader";
import { NonNativeProps, FlowioSelectProps } from "./FlowioSelect";

export const NonNativeSection: FC<
  Extract<FlowioSelectProps, NonNativeProps>
> = (props) => {
  const { emptyListMessage, loading, options } = props;

  const renderLoader = () => (
    <div>
      <Loader size={25} />
    </div>
  );

  return (
    <Fragment>
      {loading && renderLoader()}
      {!loading && !options.length && <ListItem>{emptyListMessage}</ListItem>}
    </Fragment>
  );
};
